<template>
  <div class="card floating">
    <div class="card-title">
      <h2>{{ $t('prompts.move') }}</h2>
    </div>

    <div class="card-content">
      <file-list @update:selected="val => dest = val" 
        v-bind:handles="handles"></file-list>
    </div>

    <div class="card-action">
      <button class="button button--flat button--grey" id ="buttonCancelMove"
        @click="$store.commit('closeHovers')"
        :aria-label="$t('buttons.cancel')"
        :title="$t('buttons.cancel')">{{ $t('buttons.cancel') }}</button>
      <button class="button button--flat" id ="buttonMove"
        @click="move"
        :disabled="req.url === dest"
        :aria-label="$t('buttons.move')"
        :title="$t('buttons.move')">{{ $t('buttons.move') }}</button>
    </div>
  </div>
</template>

<script>

import { mapState, mapMutations } from 'vuex';
import FileList from './FileList.vue';
import { files as api } from '@/api';
import buttons from '@/utils/buttons';
import { ROUTES } from '@/router';

export default {
  name: 'move',
  components: { FileList },
  data: function () {
    return {
      current: window.location.pathname,
      dest: null,
      items: [],
      handles: []
    };
  },
  mounted() {
    this.setIsPrompt(true);
    for (let item of this.selected) {
      this.handles.push(this.req.items[item].handle);
    }
  },
  computed: mapState(['req', 'selected', 'linkSharedDrive']),
  methods: {
    ...mapMutations(['setIsPrompt']),
    move: async function (event) {
      event.preventDefault();
      buttons.loading('move');
      document.getElementById('buttonMove').disabled = true;
      document.getElementById('buttonCancelMove').disabled = true;

      let items = [];
      let isSharedDrive = false;

      for (let index of this.selected) {
        if (this.req.items[index].type !== Module.NodeType.SHARED_DRIVE_ROOT.value) {
          let nodeList = [];
          if (this.$route.name === ROUTES.DRIVE) {
            const actionIbbLink = await ibbLink.getSortedChildren(this.req.handle, Module.SortOrderType.SORT_ORDER_CREATION_TIME.value);
            nodeList = actionIbbLink.nodeList;
          } else {
            const actionIbb = await ibb.getSortedChildren(this.req.handle, Module.SortOrderType.SORT_ORDER_CREATION_TIME.value);
            nodeList = actionIbb.nodeList;
          }
          for (let item of nodeList) {
            if (item.name === this.req.items[index].name) {
              items.push({
                from: item.handle,
                to: this.dest
              });
            }
          }
        } else if (this.dest !== '') {
          await ibb.nestSharedDrive(this.req.items[index].handle, this.dest);
          isSharedDrive = true;
        } else {
          await ibb.unnestSharedDrive(this.req.items[index].handle);
          isSharedDrive = true;
        }
      }

      if (!isSharedDrive) {
        try {
          if (this.$route.name === ROUTES.DRIVE) {
            await api.moveId(items, ibbLink);
            let parentNode = await ibbLink.getNodeById(this.dest);
            if (parentNode.node.parentHandle === '') {
              this.$router.push({ path: this.$route.path + '#' + this.linkSharedDrive });
            } else {
              this.$router.push({ path: this.$route.path + '#' + this.dest });
            }
          } else {
            await api.moveId(items);
            this.$router.push({ path: this.$route.path + '#' + this.dest });
          }
          buttons.success('move');
        } catch (e) {
          buttons.done('move');
          this.$showError(this.$t('errors.movingNode'));
          this.$store.commit('closeHovers');
        }
      } else {
        this.$store.commit('resetSelected');
        this.$store.commit('closeHovers');
      }
      
      event.preventDefault();
    }
  },
  beforeDestroy () {
    this.setIsPrompt(false);
  }
};
</script>
